
/**
 * API Service for handling HTTP requests
 * Wrapper around the Fetch API with consistent error handling and configuration
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Helper function to handle response checking
 */
const handleResponse = async (response) => {
    const isJson = response.headers.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : await response.text();

    if (!response.ok) {
        // Construct error object
        const error = (data && data.message) || response.statusText || 'API Error';
        return Promise.reject({ status: response.status, message: error, data });
    }

    return data;
};

/**
 * Generic POST request handler
 */
export const post = async (endpoint, data) => {
    const url = `${API_BASE_URL}${endpoint}`;

    const headers = {
        'Content-Type': 'application/json',
        // Add auth headers here if needed in future
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
        });

        return await handleResponse(response);
    } catch (error) {
        console.error(`API Call Failed [POST ${endpoint}]:`, error);
        throw error;
    }
};

/**
 * Service methods for specific features
 */
export const apiService = {
    // Doctors Survey
    postDoctorsSurvey: (surveyData) => {
        return post('/pilot-doctors-survey', surveyData);
    },
};

export default apiService;
